import { useContext } from 'react'

import VideoContext, { VideoContextType } from '@contexts/videoContext'

const useVideoContext = (): VideoContextType => useContext(VideoContext)

export default useVideoContext
